export const candidateCreate = {
    provide() {
        return {
            $validator: this.$validator
        };
    },
    data() {
        return {
            disableNavigation: false,
            dynamicComponent: 'candidateInformation',
            candidate: {
                poolChanges: {
                    added: [],
                    removed: []
                },
                firstName: '',
                lastName: '',
                zipcode: '',
                housenumber: null,
                street: '',
                residence: '',
                telephone: '',
                email: '',
                bsn: '',
                blacklisted: false,
                birthdate: '',
                age: null,
                gender: '',
                knownFrom: '',
                knownFromOther: '',
                language: [],
                languageOther: '',
                shifts: [],
                experiences: [],
                experienceOther: [],
                placedBy: [],
                certificates: [{
                    name: null,
                    achievedAt: null,
                    validUntil: null
                }],
                educations: [{
                    name: null,
                    level: null
                }],
                positions: [
                    {
                        name: null,
                        employer: null,
                        startDate: null,
                        endDate: null,
                        activities: null,
                        reasonLeft: null
                    },
                    {
                        name: null,
                        employer: null,
                        startDate: null,
                        endDate: null,
                        activities: null,
                        reasonLeft: null
                    }],
                travelDistance: null,
                availableDate: new Date(),
                transports: [],
                retirements: [],
                drivingLicenses: [],
                note: '',
                sick: false,
                geoLocation: {lat: null, lng: null}
            },
        };
    },
    methods: {
        setNewCandidate(newCandidate) {
            this.candidate = newCandidate;
        },
        setIntakeNote(intakeNote) {
            this.candidate.intakeNote = intakeNote;
        },
        switchHandler(value) {
            this.dynamicComponent = value;
        },
        hasUnsavedChanges(event) {
            this.disableNavigation = event;
        }
    },
    beforeRouteLeave(to, from, next) {
        if (this.disableNavigation) {
            this.swalUnsavedChanges().then(result => {
                if (result.value) {
                    next();
                }
            });
        } else {
            next();
        }
    }
};